export {AudioPlayer, MODE} from './player';

export function canPlayOggOpus() {
    return (new Audio()).canPlayType('audio/ogg; codecs=opus') !== '';
}